import React, { Component } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import io from 'socket.io-client';

import ContentWrapper from './../../template/Layout/ContentWrapper';
// Layout components
// import Sparkline from './../../template/Common/Sparklines';
import FlotChart from './../../template/Common/Flot';
import VectorMap from './../../template/Maps/VectorMap';
// import { Paper } from '@material-ui/core';
import EventsTable from './components/EventsTable';
import CardsTotals from './components/CardTotals';
// import HorizonBar from './components/HorizontalBar';
import Chart from 'react-google-charts';
import {TableLoader, FullLoader} from './components/Loader/';
import Loader from './../../Global/Loader/';
import YearsSelect from './components/CatYears';
import Axios from 'axios';
import EasyPieChart from 'easy-pie-chart';

// Styles
import './styles.scss';
import {Services} from './Services';
import { TrendData, LogisticData} from './charts.config';


const defaultColors = {
  markerColor: '#23b7e5',      // the marker points
  bgColor: 'transparent',  // the background
  scaleColors: ['#878c9a'],    // the color of the region in the serie
  regionFill: '#bbbec6'       // the base region color
};

const flotOptions = {
  legend: {
    show: false,
  },

  series: {
    lines: {
      show: false
    },
    points: {
      show: true,
      radius: 4
    },
    splines: {
      show: true,
      tension: 0.4,
      lineWidth: 1,
      fill: 0.5
    }
  },
  grid: {
    borderColor: '#eee',
    borderWidth: 1,
    hoverable: true,
    backgroundColor: '#fcfcfc',
    color: '#dee1ec',
    // markings: function (axes) {
    //   var markings = [];
    //   for (var x = Math.floor(axes.xaxis.min); x < axes.xaxis.max; x += 2)
    //     markings.push({ yaxis: { from: x, to: x + 1 }, color: '#fafafa'});
    //   return markings;
    // }
    
  },
  tooltip: true,
  tooltipOpts: {
    content: (label, x, y) => x + ' : ' + y
  },
  xaxis: {
    show: true,
    color:'#fafafa',
    tickColor: '#fcfcfc',
    mode: 'categories',
    // font: { size: 100, style: 'normal', width: 300 },
    gridLines: false
  },
  yaxis: {
    show: true,
    // min: 0,
    // max: 10, // optional: use it for a clear represetation
    tickColor: '#eee',
    autoscaleMargin: 1,
    color: '#fafafa',
    //position: 'right' or 'left',
    tickDecimals: 0,
    tickFormatter: v => v /* + ' visitors'*/
  },
  shadowSize: 1
};

let orderFillment = {
  animate: {
    duration: 800,
    enabled: true
  },
  barColor: '#23b7e5',
  trackColor: 'rgba(200,200,200,0.4)',
  scaleColor: false,
  lineWidth: 10,
  lineCap: 'round',
  size: 145
};

/*=============================================
=            Dashboard Component Functions    =
=============================================*/
async function calculateSeries(data){
  let Series = {};
  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    Series[element.country] = element.value;
  }
  return Series;
}
async function calculateLogistics(data){
  let Logistics = [['Element', 'Total',{ role: 'style' },{ sourceColumn: 0, role: 'annotation', type: 'string', calc: 'stringify'}]];
  try {
  
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      Logistics.push([element.label, element.value, element.color, element.extra]);
    }
    return Logistics;
  } catch(error){
    return Logistics;
  }
}
/*=============================================
=            Dashboard Component              =
=============================================*/
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totals: {
        Bookings: '',
        Containers: '',
        CustomerId: '',
        OrderFullfillment: '',
        POs: '',
        Shipments: '',
        VendorFullfillment: ''
      },
      flotData: [],
      Attention: [],
      Logistics: [],
      Map: [],
      loadingTrends: true,
      loadingTotals: true,
      RegionValues: {},
      fullLoader: false
    };
  }

  
  /*=============================================
  =            Get Info Dashboard Function      =
  =============================================*/
  getInfoDashBoard = async () => {
    let customer = this.props._customer;
    customer = parseInt(customer) ? parseInt(customer) : '';

    try{
      // ? Data for totals
      let response = await Axios.post(`${Services.GET_DASHBOARD_SERVICE.path}`, {
        'query': 'query Totals($num:Int!){totals(_id: $num) {CustomerId POs Bookings Shipments Containers OrderFullfillment VendorFullfillment}}',
        'variables': {'num': customer}
      });
      if (response.data && response.data.data){
        let chart = new EasyPieChart(this.refs.easypie, orderFillment);
        let chart2 = new EasyPieChart(this.refs.easypie2, orderFillment);
        chart.update(response.data.data.totals.OrderFullfillment);
        chart2.update(response.data.data.totals.VendorFullfillment);
        this.setState({totals: response.data.data.totals, loadingTotals: false});
      }

      // ? Trends For Shipment/Containers
      let trendOfOrders = await Axios.post(`${Services.GET_DASHBOARD_SERVICE.path}`, {
        query: `query Trend($customer: Int!, $user: Int!){ 
          TrendOrders(_id: $customer, user: $user) {
            Trend{label color data}
            Logistics{label value color extra}
            Attention{event impact total type launch}

            Map{name}
            MapTotals {country value}
          }
        }`,
        variables: {customer: customer, user: parseInt(this.props._user) ? parseInt(this.props._user): 0}
      });
      //Map{latLng name}
      // TrendOrders{
        // TotalAttention
      // }
      if (trendOfOrders.data && trendOfOrders.data.data){
        let Logistics = [];
        Logistics = await calculateLogistics(trendOfOrders.data.data.TrendOrders.Logistics);

        let Series = {};
        Series = await calculateSeries(trendOfOrders.data.data.TrendOrders.MapTotals);

        //let consolPlan = {event: 'Consol Plan Updated', impact: 'High', total: 285, type: 'danger', launch: 'consol-plan'};

        let Attention = trendOfOrders.data.data.TrendOrders.Attention;
        //Attention.push(consolPlan);

        //console.warn('Attention',Attention);
        
        const URL = 'https://poseidonsocketservices.azurewebsites.net/comments';
        const socket = io(URL);
        socket.emit('reset_comments', {user: this.props.user, customer: customer});
        socket.emit('disconnect');
        socket.off();
        
        let Map = trendOfOrders.data.data.TrendOrders.Map;
        this.setState({flotData: trendOfOrders.data.data.TrendOrders.Trend, Logistics, Attention, Map, loadingTrends: false, RegionValues: Series, fullLoader: true});
      } else this.resetTotalTrends();
    }catch(error){
      this.resetTotalTrends();
      this.setState({flotData: TrendData, Map: [] ,loadingTrends: false, loadingTotals: false, Logistics: await calculateLogistics(LogisticData), fullLoader: true});
    }
  }
  
  /*=============================================
  =            Reset Total Trends               =
  =============================================*/
  
  resetTotalTrends = ()  => {
    localStorage.setItem('_total_attention_', '0');
    if (document.getElementById('Badge_')) document.getElementById('Badge_').innerHTML = '0';
  }
  
  
  /*=============================================
  =            OnChange Year Search             =
  =============================================*/
  
  onChangeYear = async(data) => { // ? flotData
    let customer = this.props._customer;
    customer = parseInt(customer) ? parseInt(customer) : '';
    try{
      let TrendShipmentByYear = await Axios.post(`${Services.GET_DASHBOARD_SERVICE.path}`, {
        query: `query TrendCat($customer: Int!, $date_value: String, $user: Int!){ 
          TrendOrders(_id: $customer, date: $date_value, user: $user) {
            Trend{label color data}
          }
        }`,
        variables: {customer: customer, date_value: data.value, user: parseInt(this.props._user) ? parseInt(this.props._user): 0}
      });
      this.setState({flotData: TrendShipmentByYear.data.data.TrendOrders.Trend});
    }catch(error){
      console.error(error);
    }
  };
  

  /*=============================================
  =            Life Cicle Component             =
  =============================================*/
  
  componentDidMount() {
    this.getInfoDashBoard();
    document.getElementById('body').className = 'layout-fixed'; // !changed for nothing
  }

  /*=============================================
  =            Render Method                    =
  =============================================*/

  render() {
    const { totals, flotData, Logistics, Attention, loadingTrends, loadingTotals, RegionValues, fullLoader} = this.state;
    console.log("Logistics",Logistics)
    return (
      <>
      <Loader hidden={fullLoader}/>
      <ContentWrapper>
        <Card>
          <CardBody>
            <Row>
              <CardsTotals
                image={<img src="https://fsposeidon.blob.core.windows.net/files/29textIcon.png" width="45" height="45" alt="active_po"/>}
                // img={}
                xl={3}
                md={6}
                loading={loadingTotals}
                total={totals.POs}
                title={'Active POs'}
                propertiesIcon={'col-4 d-flex align-items-center bg-primary-dark justify-content-center rounded-left'}
                propertiesTitle={'col-8 py-3 bg-primary rounded-right'}
              />
              <CardsTotals
              // image={<img src="data:image/svg+xml;base64, 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" height="45" width="45" />}
                image={<img src="https://fsposeidon.blob.core.windows.net/files/29booking.png" width="45" height="45" alt="active_booking"/>}
                xl={3}
                md={6}
                loading={loadingTotals}
                total={totals.Bookings}
                title={'Active Bookings'}
                propertiesIcon={'col-4 d-flex align-items-center bg-purple-dark justify-content-center rounded-left'}
                propertiesTitle={'col-8 py-3 bg-purple rounded-right'}
              />
              <CardsTotals
                image={<img src="https://fsposeidon.blob.core.windows.net/files/29shipIcon.png" width="45" height="45" alt="active_shipment"/>}
                xl={3}
                md={6}
                loading={loadingTotals}
                total={totals.Shipments}
                title={'Active Shipments'}
                propertiesIcon={'col-4 d-flex align-items-center bg-green-dark justify-content-center rounded-left'}
                propertiesTitle={'col-8 py-3 bg-green rounded-right'}
              />
              <CardsTotals
                image={<img src="https://fsposeidon.blob.core.windows.net/files/29ContainerIcon.png" width="45" height="45" alt="active_containers"/>}
                xl={3}
                md={6}
                loading={loadingTotals}
                total={totals.Containers}
                title={'Active Containers'}
                propertiesIcon={'col-4 d-flex align-items-center bg-primary-dark justify-content-center rounded-left'}
                propertiesTitle={'col-8 py-3 bg-primary rounded-right'}
              />
              <Col xl={this.props._customer !== '193' ? 10: 12}>
                <Row>
                  <Col xl={6}>
                    <div className="card myCard equalsWidth">
                      <div className="card-header">
                        <div className="card-title"> Orders by Status </div>
                      </div>
                      <div className="card-body">
                        {
                          loadingTrends ? 
                            <FullLoader/>
                            :
                            <div>
                              <Chart
                                className={'_table_content'}
                                width={'100%'}
                                height={'100%'}
                                chartType="BarChart"
                                loader={<div>Loading Chart</div>}
                                data={Logistics}
                                options={{
                                  height: 360,
                                  // width: 
                                  bar: { groupWidth: '80%' },
                                  legend: { position: 'none' },
                                  animation: {
                                    startup: true,
                                    easing: 'linear',
                                    duration: 1000,
                                  }
                                }}
                                rootProps={{ 'data-testid': '6' }}
                              />
                            </div>
                        }
                      </div>
                    </div>
                  </Col>
                  <Col xl={6}>
                    { /* START card */}
                    <div className="card myCard equalsWidth">
                      <div className="card-header">
                        <Col md={12}>
                          <Row>
                            <Col md={8}>
                              <div className="card-title"> Trend of Shipments / Containers </div>
                            </Col>
                            <Col md={4}>
                              <YearsSelect onChangeYear={this.onChangeYear}/>
                            </Col>
                          </Row>
                        </Col>
                      </div>
                      <div className="card-body mx-md-n5">
                        {
                          loadingTrends ? 
                            <FullLoader/>
                            :<FlotChart data={flotData} options={flotOptions} width={'100%'} height={'95%'}/>
                        }
                      </div>
                    </div>
                    { /* END widget */}
                  </Col>

                  <Col xl={6}>
                    <Card className="myCard equalsWidth">
                      <div className="card-header">
                        <div className="card-title"> Events that Require Attention </div>
                      </div>
                      <CardBody>
                        {loadingTrends ? 
                          <TableLoader/>
                          :<EventsTable data={Attention}/>
                        }
                      </CardBody>
                    </Card>
                  </Col>

                  <Col xl={6}>
                    <Card className="myCard equalsWidth">
                      <div className="card-header">
                        <div className="card-title"> Orders by Origin Country </div>
                      </div>
                      <CardBody>
                        {
                          loadingTrends ? 
                            <FullLoader/>
                            : <VectorMap 
                              options={{
                                map: 'world_mill_en',
                                backgroundColor: defaultColors.bgColor,
                                zoomMin: 1,
                                zoomMax: 8,
                                zoomOnScroll: false,
                                regionStyle: {
                                  initial: {
                                    'fill': defaultColors.regionFill,
                                    'fill-opacity': 1,
                                    'stroke': 'none',
                                    'stroke-width': 1.5,
                                    'stroke-opacity': 1
                                  },
                                  hover: {
                                    'fill-opacity': 0.8
                                  },
                                  selected: {
                                    fill: 'blue'
                                  },
                                  selectedHover: {}
                                },
                                focusOn: {
                                  x: 0.4,
                                  y: 0.6,
                                  scale: 1
                                },
                                markerStyle: {
                                  initial: {
                                    fill: defaultColors.markerColor,
                                    stroke: defaultColors.markerColor,
                                  }
                                },
                                onRegionLabelShow: (e, el, code) => {
                                  if (RegionValues[code])
                                    el.html(el.html() + ': ' + RegionValues[code] + ' orders');
                                }
                              }}
                              series={{regions: [{
                                values: RegionValues,
                                scale: defaultColors.scaleColors,
                                normalizeFunction: 'polynomial'
                              }]}}
                              markers={[]}
                            />
                        }
                      </CardBody>
                    </Card>
                  </Col>

                </Row>
              </Col>
              {/* </Row> */}
              <Col xl={2} md={12} sm={12} hidden={this.props._customer !== '193' ? false: true}>
                { /* START loader widget */}
                <div className="card myCard">
                  <div className="card-body">
                    {/* <a className="text-muted float-right" href=""> */}
                    {/* <em className="fa fa-arrow-right"></em> */}
                    {/* </a> */}
                    <div className="text-info">Order Fulfillment</div>
                    <div className="text-center py-4">
                      <div ref="easypie" data-percent="0" className="easypie-chart easypie-chart-lg">
                        <span>{totals.OrderFullfillment}%</span>
                      </div>
                    </div>
                  </div>
                </div>
                { /* END loader widget */}
                { /* START loader widget */}
                <div className="card myCard">
                  <div className="card-body">
                    {/* <a className="text-muted float-right" href=""> */}
                    {/* <em className="fa fa-arrow-right"></em> */}
                    {/* </a> */}
                    <div className="text-info">Vendor Fulfillment</div>
                    <div className="text-center py-4 _center">
                      <div ref="easypie2" data-percent="0" className="easypie-chart easypie-chart-lg">
                        <span>{totals.VendorFullfillment}%</span>
                      </div>
                    </div>
                  </div>
                </div>
                { /* END loader widget */}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </ContentWrapper>
      </>
    );
  }
}

export default withRouter(Dashboard);